export default "__VITE_ASSET__BPwNfeMC__"